export class CustomerUsageLimit {
    customerUsageLimitId: number;
    customerId: number;
    streamingUsage: number;
    maxLrsUsers: number;
    fileStorage: number;
    maxUsers: number;
}